import React, { useState } from 'react';
import { HeroFormPsk } from '../hero-form-psk/hero-form-psk';
import { HeroFormPayment } from '../hero-form-payment/hero-form-payment';
import { cn } from 'lib/utils';

export const HeroForms = ({ className }: { className?: string }) => {
  const [isFirstFormOpened, setFirstFormOpened] = useState(false);
  const [isSecondFormOpened, setSecondFormOpened] = useState(false);

  const handleOpenFirstForm = () => {
    setFirstFormOpened(!isFirstFormOpened);
    setSecondFormOpened(isFirstFormOpened);
  };

  const handleOpenSecondForm = () => {
    setFirstFormOpened(!isFirstFormOpened);
    setSecondFormOpened(isFirstFormOpened);
  };

  return (
    <div className={cn('h-full flex flex-col justify-center gap-6', className)}>
      <HeroFormPsk
        isFirstFormOpened={isFirstFormOpened}
        handleOpenFirstForm={handleOpenFirstForm}
      />
      <HeroFormPayment
        isSecondFormOpened={isSecondFormOpened}
        handleOpenSecondForm={handleOpenSecondForm}
      />
    </div>
  );
};
